// removed by extract-text-webpack-plugin
module.exports = {"comments_modal":"Comments__comments_modal__2sDzT","comments":"Comments__comments__1oXUs","comment":"Comments__comment__HXPGM","form":"Comments__form__2IX8l","post_edit":"Comments__post_edit__1u53l","button":"Comments__button__2I1OU","list_action_button":"Comments__list_action_button__1tu29","delete":"Comments__delete__3FMcx","add":"Comments__add__3jOZo","posting":"Comments__posting__2erHZ","validation_label":"Comments__validation_label__2kWU9","invalid_input":"Comments__invalid_input__3HQri","field_item":"Comments__field_item__lll8N"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Comments/Comments.css
// module id = 443
// module chunks = 0